import * as ProposalNS from '../../Proposal';
import * as ProposalElementNS from '../../ProposalElements';
import { ComparisonItemBasedProposalDAO } from '../ProposalDAOImpl';
import LineSeriesDataPoint from '@/types/line-series-data-point';
import { ComparisonItemDAO } from '../ProposalItemDAO';
import LineSeriesData from '@/types/line-series-data';
import { DataPoints } from '../DataPoints';
import { createLineSeriesEntry } from '@/utils/hypothetical-return';
import { generateHistoricalScenariosPlotBands, generateScenarioEdgeMarkers } from '@/utils/historical-scenarios/plot-bands';

export default class HistoricalScenariosGraphDAO extends ComparisonItemBasedProposalDAO {
  series: LineSeriesDataPoint[][];

  out: LineSeriesData[] = [];

  constructor(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement) {
    super(proposal, proposalElement);
    this.series = [];
  }

  public static buildInstance(proposal: ProposalNS.Proposal, proposalElement: ProposalElementNS.ProposalDataElement): HistoricalScenariosGraphDAO {
    return new HistoricalScenariosGraphDAO(proposal, proposalElement);
  }

  protected build(): void {
    if (
      this.sectionIteratorIndex === null ||
      !this.proposal.selectedHistoricalScenarios ||
      this.proposal.calculatedHistoricalScenarios === undefined ||
      this.proposal.calculatedHistoricalScenarios.length === 0
    ) {
      return;
    }
    const itemDAOs: ComparisonItemDAO[] = this.getItemDAOs();
    const items = itemDAOs.map(i => i.item);

    // Filter scenarios to only include those that are selected in the proposal

    const scenario = this.proposal.selectedHistoricalScenarios[this.sectionIteratorIndex];
    const calculatedScenario = this.proposal.calculatedHistoricalScenarios?.find(s => s.historicalScenario._id === scenario._id);

    if (!calculatedScenario) {
      return;
    }

    this.series = items.map(
      item => DataPoints.getHistoricalScenarioSeriesForRollings(calculatedScenario.items.find(i => i._id === item._id)?.rolling || [], 100000).response,
    );

    const disclaimerKeys = items.map(
      item => DataPoints.getHistoricalScenarioSeriesForRollings(calculatedScenario.items.find(i => i._id === item._id)?.rolling || [], 100000).disclaimerKeys,
    );

    const adisclaimerKeys = disclaimerKeys.flat();

    for (const disclaimerKey of adisclaimerKeys) {
      this.addDisclaimerConfigs([
        {
          key: disclaimerKey,
          config: { scenario },
          items: itemDAOs.map(itemDAO => itemDAO.item),
        },
      ]);
    }

    this.out = this.series.map((serie, index) => {
      const itemDAO = itemDAOs[index];
      return createLineSeriesEntry(
        itemDAO,
        this.proposalElement.DAO as ProposalNS.HypotheticalReturnConfig,
        this.proposal,
        this.series,
        this.locale,
        itemDAO.item.color || null,
        index,
      );
    });
  }

  protected getColorKeys(): string[] {
    return [];
    // throw new Error("Method not implemented.");
  }

  getLineSeries(): LineSeriesData[] {
    return this.out;
  }

  getGraphConfigOptions(): ProposalNS.ChartConfigOptions {
    if (
      this.sectionIteratorIndex === null ||
      !this.proposal.selectedHistoricalScenarios ||
      this.proposal.calculatedHistoricalScenarios === undefined ||
      this.proposal.calculatedHistoricalScenarios.length === 0
    ) {
      return {};
    }

    const scenario = this.proposal.selectedHistoricalScenarios[this.sectionIteratorIndex];
    const plotBands = generateHistoricalScenariosPlotBands([scenario]);
    const plotLines = generateScenarioEdgeMarkers([scenario]);
    return { xAxis: { plotBands, plotLines } };
  }
}
